import React from "react";
import PageHeroSection from "../../components/ui/PageSections/PageHeroSection";
import EmpowerServicesSection from "../../components/ui/PageSections/EmpowerServicesSection";
import Section from "../../components/ui/Section";
import iconBgp from "../../images/icons/icon-bgp.svg";
import TertiaryInputTable from "../../components/ui/InputTables/TertiaryInputTable";
import PresenceBanner from "../../components/ui/PageSections/PresenceBanner";
import ContactUsBanner from "../../components/ui/PageSections/ContactUsBanner";

const BgpPageTemplate = ({ pageContext, translations }) => {
	return (
		<div>
			<PageHeroSection
				heroIcon={iconBgp}
				heroIconAltText="White rombus rack icon"
				intro={translations["BGPIntro"]}
				heroTitle={
					translations["BGPMainTitle"]
						? translations["BGPMainTitle"]
						: pageContext.h1Title
				}
				subtitle={
					translations["BGPSubtitle"]
						? translations["BGPSubtitle"]
						: pageContext.h2Title
				}
			/>
			<TertiaryInputTable
				serviceType="bgp"
				defaultIataCode={pageContext.iataCode}
				translations={translations}
				pageContext={pageContext}
				featureList={["IPv4 / IPv6 support", "Multihoming"]}
			/>
			<section className="pb-20 px-4">
				<EmpowerServicesSection translations={translations} />
			</section>
			<Section color="white">
				<PresenceBanner translations={translations} />
			</Section>
			<Section color="transparent">
				<ContactUsBanner
					title={translations["BGPContactUsBannerTitle"]}
					subtitle={translations["BGPContactUsBannerText"]}
					contactText={translations["contact"]}
				/>
			</Section>
		</div>
	);
};

export default BgpPageTemplate;
